import "containers/Account/Register/Register.css";
import React from "react";
import AxiosConfig from "axiosConfig";
import CustomInput from "components/General/Form/CustomInput";
import { connect } from "react-redux";
import TextTheme from "components/General/Text/TextTheme";
import RoundedButton from "components/General/Form/CustomButton/RoundedButton";
import CustomBanner from "components/General/Form/CustomBanner";
import CustomCheckbox from "components/General/Form/CustomCheckbox";
import * as ProfileHelper from "components/Account/Profile/ProfileHelper";
import CustomA from "components/General/Text/customA";
import * as CONSTANT from "constants/text";
import queryString from "query-string";
import CustomDatepicker from "components/General/Form/CustomDatepicker";

const parsed = queryString.parse(window.location.search);

class RegisterStepTwo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      name: "",
      username: "",
      password: "",
      repassword: "",
      emailError: "",
      usernameError: "",
      nameError: "",
      passwordError: "",
      repasswordError: "",
      is_checked_terms_privacy: false,
      is_above_eighteen: false,
      termsPrivacyError: "",
      check: false,
      registerStatusMsg: "",
      ageError: "",
      dob: "",
      errorMap: new Map(),
      registerStatus: "",
    };
  }

  componentDidMount() {
    if (!sessionStorage.getItem("registerEmail") && !parsed.name) {
      this.props.history.push("/log-in");
    } else if (parsed.name && parsed.email) {
      this.setState({ email: parsed.email, name: parsed.name });
    } else {
      this.setState({
        email: sessionStorage.getItem("registerEmail"),
        name: sessionStorage.getItem("registerName"),
      });
    }
  }

  validInputs() {
    let flag = true;
    if (this.state.name === "") {
      this.setState({ nameError: CONSTANT.EMPTY_NAME });
      flag = false;
    }
    if (this.state.email === "") {
      this.setState({ emailError: CONSTANT.EMPTY_EMAIL });
      flag = false;
    }
    if (this.state.username === "") {
      this.setState({ usernameError: CONSTANT.EMPTY_USERNAME });
      flag = false;
    }
    if (this.state.password === "") {
      this.setState({ passwordError: CONSTANT.EMPTY_PASSWORD });
      flag = false;
    }
    if (!this.state.is_checked_terms_privacy) {
      this.setState({
        termsPrivacyError: CONSTANT.EMPTY_TERMS_PRIVACY,
      });
      flag = false;
    }
    this.validateUsername();
    this.validatePassword();
    this.validateRePassword();
    ProfileHelper.validateDobSignUp.bind(this)();
    if (
      this.state.usernameError !== "" ||
      this.state.passwordError !== "" ||
      this.state.repasswordError !== "" ||
      this.state.termsPrivacyError !== "" ||
      this.state.errorMap.has("dobError")
    ) {
      flag = false;
    }
    return flag;
  }

  handleSubmit = (event) => {
    event.preventDefault();
    if (this.validInputs()) {
      this.validateAvailabilityUsername();
    }
  };

  validateAvailabilityUsername() {
    let usernameAvailability = ProfileHelper.validateAvailabilityUsername(
      this.state.username,
      this.state.email
    );
    let obj = this;
    usernameAvailability.then(function (result) {
      if (result) {
        obj.setState({ usernameError: "" });
        obj.registerUser();
      } else {
        obj.setState({
          usernameError: CONSTANT.NOT_AVAILABLE_USERNAME,
        });
      }
    });
  }

  registerUser() {
    let form_data = new FormData();
    var date = new Date(this.state.dob),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    let finalDate = [date.getFullYear(), mnth, day].join("-");
    form_data.append("email", this.state.email);
    form_data.append("password", this.state.password);
    form_data.append("full_name", this.state.name);
    form_data.append("username", this.state.username);
    form_data.append("is_checked_tnc", true);
    form_data.append("is_checked_privacy", true);
    form_data.append("is_above_eighteen", this.state.is_above_eighteen);
    form_data.append("dob", finalDate);
    AxiosConfig.post("account/register/", form_data)
      .then((res) => {
        this.setState({ registerStatus: res.data["status"] });
        if (res.data["status"] !== CONSTANT.BACKEND_SUCCESS) {
          this.setState({ registerError: res.data["status"] });
        } else {
          this.props.history.push({
            pathname: "/log-in",
            state: { isVerify: false },
          });
        }
      })
      .catch();
  }

  onDataChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
      registerStatus: "",
    });
    this.validate(event);
  };

  onCheckboxChange = (event) => {
    this.setState({
      [event.target.name]: event.target.checked,
      [event.target.value]: event.target.checked,
      registerStatus: "",
    });
    if (event.target.name === "is_checked_terms_privacy") {
      this.setState({
        is_checked_terms_privacy: !this.state.is_checked_terms_privacy,
        termsPrivacyError: "",
      });
    }
  };

  validate = (event) => {
    if (event.target.name === "username") {
      this.validateUsername();
    }
    if (event.target.name === "password") {
      this.validatePassword();
    }
    if (event.target.name === "repassword") {
      this.validateRePassword();
    }
  };

  validateUsername = () => {
    const { username } = this.state;
    // const usernameRegex = /^(?=.*[a-zA-Z0-9_]).{6,20}$/;
    const usernameRegex = /^[a-zA-Z0-9]{6,20}$/;
    this.setState({
      usernameError: username.match(usernameRegex)
        ? ""
        : CONSTANT.INVALID_USERNAME,
    });
  };
  validatePassword = () => {
    const { password } = this.state;
    const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/;

    this.setState({
      passwordError: password.match(passwordRegex)
        ? ""
        : CONSTANT.INVALID_PASSWORD,
    });
  };

  validateRePassword = () => {
    const { repassword } = this.state;
    const password = this.state.password;
    this.setState({
      repasswordError:
        repassword === password ? "" : CONSTANT.INVALID_PASSWORD_MATCH,
    });
  };

  render() {
    const registerStatusMessage = () => {
      switch (this.state.registerStatus) {
        case CONSTANT.BACKEND_USER_ALREADY_EXISTS:
          return CONSTANT.USER_REGISTRATION_EXIST;
        case CONSTANT.BACKEND_SUCCESS:
          return CONSTANT.USER_REGISTRATION_SUCCESS;
        default:
          return this.state.registerStatus;
      }
    };

    return (
      <div style={{ textAlign: "-webkit-center" }}>
        <CustomBanner message="Complete your enrollment." />
        <div className="form_register">
          <h5 className="subtitle">
            <TextTheme
              message="2. Sign up with email."
              className="text_medium text_dark_blue"
            />
          </h5>
          <div className="change-email">
            Need to change your name or email?
            <CustomA href="/register-step-one">Go back.</CustomA>
          </div>
          <br></br>
          <br></br>
          <form onSubmit={this.handleSubmit}>
            <CustomInput
              name="name"
              placeholder="Name"
              value={this.state.name}
              readOnly
            />
            <CustomInput
              name="email"
              placeholder="Email"
              value={this.state.email}
              readOnly
            />
            <CustomInput
              name="username"
              error={this.state.usernameError}
              placeholder="Username"
              value={this.state.username}
              handleChange={this.onDataChange.bind(this)}
              handleBlur={this.validate.bind(this)}
            />
            <CustomInput
              name="password"
              type="password"
              error={this.state.passwordError}
              placeholder="Password"
              value={this.state.password}
              handleChange={this.onDataChange.bind(this)}
              handleBlur={this.validate.bind(this)}
            />
            <CustomInput
              name="repassword"
              type="password"
              error={this.state.repasswordError}
              placeholder="Confirm Password"
              value={this.state.repassword}
              handleChange={this.onDataChange.bind(this)}
              handleBlur={this.validate.bind(this)}
            />
            <div className="sign-up-dob">
              <p>
                Please enter your date of birth to determine your eligibility to
                create an individual account.
              </p>
              <CustomDatepicker
                name="dob"
                label={CONSTANT.BIRTH_DATE_COLON}
                value={this.state.dob}
                handleChange={this.onDataChange.bind(this)}
                placeholder="MM/DD/YYYY"
                error={
                  this.state.errorMap.has("dobError")
                    ? this.state.errorMap.get("dobError")
                    : ""
                }
              />
            </div>
            <CustomCheckbox
              name="is_checked_terms_privacy"
              value="True"
              defaultChecked={this.state.is_checked_terms_privacy}
              handleChange={this.onCheckboxChange.bind(this)}
              text={
                <React.Fragment>
                  By clicking the box, I affirm that I have read and agree to
                  Katamundi's
                  <CustomA href="/terms-and-conditions" target="_blank">
                    Terms of Use
                  </CustomA>
                  and{" "}
                  <CustomA href="/security-and-privacy" target="_blank">
                    Privacy Policy
                  </CustomA>
                </React.Fragment>
              }
              error={this.state.termsPrivacyError}
            />
            <div style={{ display: "flex" }}>
              <div style={{ marginLeft: "auto" }}>
                <RoundedButton
                  title="&nbsp;&nbsp;&nbsp;Submit&nbsp;&nbsp;&nbsp;"
                  buttonClassName="background_dark_orange form_button"
                  textThemeClassName="text_medium text_white"
                  handleOnClick={this.handleSubmit}
                />
              </div>
            </div>
            <div style={{ width: "100%", textAlign: "center" }}>
              <TextTheme
                message={registerStatusMessage()}
                className="text_small text_red"
              />{" "}
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default connect()(RegisterStepTwo);
